import { getToken,axiosInstance } from "../utils/Api";

export const getStorageContent = async () =>{ 
    try {
        const response = await axiosInstance.get(`/admin/acl/getBucketData`,{
            headers: { 
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  } 

 

  export const fetchFolderContent = async (path) =>{ 
    try {
        const response = await axiosInstance.get(`/admin/acl/getBucketData?folder=${path}`,{
            headers: { 
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  } 

  

